import jQuery from "jquery";

document.addEventListener('DOMContentLoaded', () => {

    jQuery('.swatch-filter').each(function () {
        const table_rows = jQuery(this).closest('.c-swatch-form')
            .find('.c-product-simple-products__table__row[data-name]');


        jQuery(this).keyup(function () {

            const val = jQuery(this).val().toLowerCase();

            if (val.length < 3) {
                return;
            }

            table_rows.addClass('hidden')
                .filter(function () {
                    return (jQuery(this).data('name').indexOf(val) >= 0);
                })
                .removeClass('hidden');
        });
    });

});